import React from 'react';
import "../FooterComponent/Footer.css";
import Logo from "../../Images/Logo/New Footer Logo.png";
import { Link } from 'react-router-dom';

const Footer = () => {
    // Function to scroll smoothly to the top of the page
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Use 'auto' for an instant jump without animation
        });
    };

    return (
        <>
            <section className='footer-section-1'>
                <div className='footer-section-1-main-con'>
                    <div className='footer-section-logo-con'>
                        <Link to="/" onClick={scrollToTop}>
                            <div className='footer-section-logo'>
                                <img src={Logo} alt='Logo' />
                            </div>
                        </Link>
                    </div>

                    <div className='footer-section-details-con'>
                        <div className='row footer-rows'>
                            <div className='col-md-4 footer-col'>
                                <div className='footer-section-menu-info-con'>
                                    <div className='footer-section-address-info-head'>
                                        <h3 className='head-style'>Information</h3>
                                    </div>
                                    <div className='footer-section-menu-info'>
                                        <Link to="/return-policy" onClick={scrollToTop}>
                                            Returns
                                        </Link>
                                        <Link to="/shipping-policy" onClick={scrollToTop}>
                                            Shipping
                                        </Link>
                                        <Link to="/privacy-policies" onClick={scrollToTop}>
                                            Privacy
                                        </Link>
                                        <Link to="/terms-conditions" onClick={scrollToTop}>
                                            Terms & Conditions
                                        </Link>
                                        <Link to="/contact" onClick={scrollToTop}>
                                            Contact
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4 footer-col'>
                                <div className='footer-section-menu-info-con'>
                                    <div className='footer-section-address-info-head'>
                                        <h3 className='head-style'>Quick Links</h3>
                                    </div>
                                    <div className='footer-section-menu-info'>
                                        <Link to="/" onClick={scrollToTop}>
                                            Home
                                        </Link>
                                        <Link to="/about" onClick={scrollToTop}>
                                            About
                                        </Link>
                                        <Link to="/accessories" onClick={scrollToTop}>
                                            Accessories
                                        </Link>
                                        <Link to="/fragrance" onClick={scrollToTop}>
                                            Fragrance
                                        </Link>
                                        <Link to="/apparel" onClick={scrollToTop}>
                                            Apparel
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4 footer-col'>
                                <div className='footer-section-menu-info-con'>
                                    <div className='footer-section-address-info-head'>
                                        <h3 className='head-style'>Stay Connected</h3>
                                    </div>
                                    <div className='footer-section-menu-info'>
                                        <a href='https://www.instagram.com/1fiveglobal?igsh=MnRxenNtZWozMWhw' target='_blank' rel='noopener noreferrer'>
                                            Instagram
                                        </a>
                                        <a href='https://www.facebook.com/people/1FiveLuxury/61573584849714/?mibextid=wwXIfr&rdid=hwasKI33z05nluQt&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Eq18XeuAx%2F%3Fmibextid%3DwwXIfr' target='_blank' rel='noopener noreferrer'>
                                            Facebook
                                        </a>
                                        <a href='https://x.com/1fiveluxury?s=21&t=abNZb9BXQdbo-Hy7hi12Xg' target='_blank' rel='noopener noreferrer'>
                                            X (Twitter)
                                        </a>
                                        <a href='https://www.youtube.com/@1fiveluxury' target='_blank' rel='noopener noreferrer'>
                                            YouTube
                                        </a>
                                        <a href="mailto:1FiveLuxury@gmail.com" target='_blank' rel='noopener noreferrer'>
                                            Email Us
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Footer;